import { Cross } from "@taroify/icons/index.js";
import { cloneIconElement } from "@taroify/icons/utils/index.js";
import { View } from "@tarojs/components";
import classNames from "classnames";
import * as React from "react";
import { prefixClassname } from "../styles/index.js";
function UploaderRemove(props) {
    const { className, icon = React.createElement(Cross, null), ...restProps } = props;
    return (React.createElement(View, { className: classNames(prefixClassname("uploader__preview-remove"), className), ...restProps }, cloneIconElement(icon, { className: prefixClassname("uploader__preview-remove-icon") })));
}
export default UploaderRemove;
